var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{ref:"barChart",attrs:{"type":"bar","options":_vm.apexoptions,"series":_vm.series}}),_c('div',{staticClass:"bar-graph-bottom-text"},[_vm._v(_vm._s(_vm.bottomText || ''))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }